import React from 'react'
import type { FlexyAlmacen } from '../../../types/flexyAlmacenes'
import { selectAlmacenOptions } from '../../../utils/flexyAlmacenesSelect'

interface FlexyAlmacenSelectProps {
  id: string
  label: string
  value: number | ''
  onChange: (value: number) => void
  options: readonly FlexyAlmacen[]
  isLoading?: boolean
  disabled?: boolean
  excludeId?: number | ''
}

const FlexyAlmacenSelect: React.FC<FlexyAlmacenSelectProps> = ({
  id,
  label,
  value,
  onChange,
  options,
  isLoading = false,
  disabled = false,
  excludeId = ''
}) => {
  const visibleOptions = selectAlmacenOptions(options, excludeId)
  const isDisabled = disabled || isLoading

  return (
    <div>
      <label htmlFor={id} className="block text-sm font-medium text-gray-700 mb-1">
        {label}
      </label>
      <select
        id={id}
        value={value}
        onChange={(event) => onChange(Number(event.target.value))}
        disabled={isDisabled}
        aria-label={label}
        aria-busy={isLoading}
        className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-custom-blue focus:outline-none focus:ring-1 focus:ring-custom-blue disabled:bg-gray-100"
      >
        <option value="">
          {isLoading ? 'Cargando almacenes...' : 'Seleccionar almacén'}
        </option>
        {visibleOptions.map((almacen) => (
          <option key={almacen.value} value={almacen.value}>
            {almacen.label}
          </option>
        ))}
      </select>
    </div>
  )
}

export default FlexyAlmacenSelect
